import Tooltip from '@ui/tooltip/Tooltip';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const ProductBoutiqueSelected = (props) => {
    const { store, onArrowBack, withBorder } = props;
    const { t } = useTranslation();
    if (!store) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: classNames('product-reserve__detail__selected-store', { 'has-back': !!onArrowBack }, { 'with-border': withBorder }) },
        !!onArrowBack && (React.createElement("button", { className: "back-button", "aria-label": t('button.back'), onClick: () => {
                onArrowBack();
                document.querySelector('.product-reserve__main').classList.remove('zoom-product');
            } })),
        React.createElement("div", null,
            props.appointmentType == 552250001 && store.liveBoutique && (React.createElement("div", { className: "option-store__live-boutique" },
                React.createElement("span", { className: "primary-xxs" }, t('bookanappointment.liveboutique')),
                React.createElement(Tooltip, { ariaLabel: t('label.info'), checkout: true, id: `${store.ID}-live-boutique-info`, icon: "info", className: "live-boutique-info", text: t('bookanappointment.liveboutiquetoltip', { 0: window.liveBoutiqueUrl }) }))),
            React.createElement("p", { className: "name bold primary-s" }, store.name),
            React.createElement("p", { className: "content" },
                store.address1,
                " ",
                store.address2,
                " ",
                store.city,
                React.createElement("br", null),
                store.phone))));
};
export default ProductBoutiqueSelected;
